import CircleLoader from "components/CircleLoader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { postRequest } from "utils/apiRequest";


const SubscriptionCallbackPage = () => {

    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const urlSearch = new URLSearchParams(window.location.search);

        const planName = urlSearch.get('plan');
        const setupIntent = urlSearch.get('setup_intent');
        const setupIntentClientSecret = urlSearch.get('setup_intent_client_secret');
        
        handleCallback(planName, setupIntent, setupIntentClientSecret);
    }, [])

    const handleCallback = (planName, setupIntent, setupIntentClientSecret) => {
        postRequest('/subscription/callback', {
            plan: planName.toLowerCase(),
            setupIntent: setupIntent,
            setupIntentClientSecret: setupIntentClientSecret
        }).then(d => {
            if(d && d.stripe_id){
                // allow time for webhook to arrive
                setTimeout(()=>{
                    navigate('/subscriptions')
                }, 5000)
            }
        })
    }
      return (loading ? <CircleLoader /> : <></>);
}

export default SubscriptionCallbackPage;